import {createFileRoute} from '@tanstack/react-router'
import {SwapDepositStep} from "@/components/wallet/WalletSwap/SwapDepositStep/SwapDepositStep.tsx";
import {z} from 'zod'


const swapDepSchema = z.object({
  // idmKey: z.string().nonempty(),
  amount: z.string().nonempty(),
  usdc: z.string().nonempty(),
  fromToken: z.string().nonempty(),
  fromNetwork: z.string().nonempty(),
  toToken: z.string().nonempty(),
  toNetwork: z.string().nonempty(),
})

export const Route = createFileRoute('/_mainLayout/wallet/swap/deposit/$idmKey/')({
  component: RouteComponent,
  validateSearch: swapDepSchema,
})

function RouteComponent() {
  const {idmKey} = Route.useParams()
  return <SwapDepositStep idmKey={idmKey}/>
}
